import {toast} from 'react-toastify';
import {useQuery} from '@tanstack/react-query';
import {LocalStorage} from '@guestapp/core';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {
  DocumentsServiceError,
  Guidebook,
  LS_I18NEXT_LNG_KEY,
  PaginatedV2,
} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = {
  reservationId: string;
};

function useFetchGuidebooks({reservationId}: Props) {
  const {getGuidebooks} = useChekinSDK();
  const language = LocalStorage.get<string>(LS_I18NEXT_LNG_KEY);
  const result = useQuery<PaginatedV2<Guidebook>, DocumentsServiceError>(
    [QUERY_CACHE_KEYS.guidebooks, reservationId, language],
    () => getGuidebooks(reservationId),
    {
      enabled: Boolean(reservationId),
      refetchOnWindowFocus: false,
      onError: error => {
        const errorMessage = error.detail ? error.detail[0].msg : error.message;
        toast.error(errorMessage, {
          theme: 'colored',
        });
      },
    },
  );

  return result;
}

export {useFetchGuidebooks};
